import { memo } from "react";

function WINGPickupStopMarker({ stopNo, backgroundColor, textColor }) {
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -3;
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.5 7C29.5 10.5899 26.5899 13.5 23 13.5C19.4101 13.5 16.5 10.5899 16.5 7C16.5 3.41015 19.4101 0.5 23 0.5C26.5899 0.5 29.5 3.41015 29.5 7ZM14.5 8.7002C14.5 12.1218 17.1438 14.9259 20.5 15.1813V24.7002C20.5 26.6332 18.933 28.2002 17 28.2002H4C2.067 28.2002 0.5 26.6332 0.5 24.7002V11.7002C0.5 9.7672 2.067 8.2002 4 8.2002H14.519C14.5064 8.36529 14.5 8.53203 14.5 8.7002Z"
        fill={backgroundColor}
        stroke={textColor}
      />
      <path
        d="M12.8351 15.3552H6.46015C6.21015 15.3552 6.02395 15.0231 6.02395 14.6776C6.02395 14.3305 6.193 14 6.46015 14H12.8351C12.9623 14 13.2401 14.308 13.2401 14.6776C13.2401 15.1575 12.8351 15.3552 12.8351 15.3552Z"
        fill={textColor}
      />
      <path
        d="M6.46015 24C6.21015 24 6 23.6068 6 23.3568C6 23.1068 6.21015 22.7136 6.46015 22.7136H12.8351C13.0851 22.7136 13.2843 23.1068 13.2843 23.3568C13.2843 23.6664 13.0226 24 12.8351 24H6.46015Z"
        fill={textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.77265 23.5625C6.77265 23.8125 6.96015 24 7.21015 24H12.0226C12.2726 24 12.4601 23.8125 12.5226 23.5625V21.5C12.5226 20.4375 11.9601 19.5 11.0226 19C11.9601 18.5 12.5226 17.5625 12.5226 16.5V14.4375C12.5226 14.1875 12.3351 14 12.0851 14H7.21015C6.96015 14 6.77265 14.1875 6.77265 14.4375V16.5C6.77265 17.5625 7.33515 18.5 8.27265 19C7.33515 19.5 6.77265 20.4375 6.77265 21.5V23.5625ZM11.3226 21.1312V22.5125H7.92265V21.1844C7.92265 20.4937 8.61306 19.8587 9.25056 19.5931C9.35681 19.5399 9.46306 19.3806 9.46306 19.2743V18.7962C9.46306 18.6368 9.35681 18.4774 9.25056 18.4774C8.61306 18.2118 7.92265 17.5719 7.92265 16.8812V15.5H11.3226V16.8281C11.3226 17.5187 10.7244 18.1489 10.0869 18.4146C9.9275 18.4677 9.87438 18.6271 9.87438 18.7864V19.2114C9.87438 19.3708 9.9275 19.5302 10.0869 19.5302C10.7244 19.7958 11.3226 20.4406 11.3226 21.1312Z"
        fill={textColor}
      />
      <text
        id={2}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={8}
        fontWeight={500}
        fill={textColor}
      >
        <tspan x={21 + shiftLeft} y={10}>
          {stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(WINGPickupStopMarker);
